import React from "react";
import { useState } from "react";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "Wie lange dauert der Nothelferkurs bzw. VKU Kurs?",
      answer:
        "Der Nothelferkurs dauert 10 Stunden. Der VKU Kurs dauert 8 Stunden. Der Kurs wird mehrheitlich am Samstag und Sonntag oder am Abend durchgeführt.",
    },
    {
      question: "Was muss ich zum Kurs mitbringen?",
      answer:
        "Zum Kurs musst du das Kursgeld in bar sowie ein Notizblock mitbringen.",
    },
    {
      question: "Wie wird die Teilnahme bestätigt?",
      answer:
        "Am Ende vom Nothlferkurs bekommst du einen Nothleferausweis, welcher 6 Jahre gültig ist. Der VKU Kurs wird direkt auf SARI online bestätigt.",
    },
    {
      question: "Wann solltest du diese Kurse am besten besuchen?",
      answer:
        "Beide Kurse sind verpflichtend. Den Nothelferkurs musst du vor der Theorieprüfung besuchen. Den VKU Kurs kannst du gleich nach der Theorieprüfung besuchen. Spätestens für die Anmeldung zur praktischen Fahrprüfung musst der VKU Kurs auch abgeschlossen sein.",
    },
    // {
    //   question:
    //     "What benefits does the Red Cross course offer for road safety?",
    //   answer:
    //     "The red cross course provides essential first aid skills, enabling you to respond effectively in emergencies.",
    // },
  ];

  return (
    <div className="max-w-5xl mx-auto p-4 space-y-2">
      {faqItems.map((item, index) => (
        <div
          key={index}
          className={`border-b border-gray-300 pb-2 px-5 ${
            index === 0 && "border-t pt-2"
          }`}
        >
          {/* Question */}
          <button
            onClick={() => toggleAccordion(index)}
            className="w-full flex justify-between items-center text-left text-xl text-dark-blue font-semibold py-2"
          >
            {item.question}
            <span
              className={`text-light-blue transform ${
                activeIndex === index ? "rotate-180" : "rotate-0"
              } transition-transform duration-200 `}
            >
              ▼
            </span>
          </button>

          {/* Answer */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              activeIndex === index
                ? "max-h-[500px] opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            {activeIndex === index && (
              <p className="mt-2 text-gray-600">{item.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
